import React from 'react';
import { useTheme } from '@mui/material/styles';
import { Box, Grid, Typography } from '@mui/material';
import ActionCTA from '../../shared/eir-action-cta/ActionCTA';
import useStyles from './style';
import getBannerImage from './banner.util';
import { BANNER_BACKGROUND } from '../../shared/Constants';

const { LIGHT } = BANNER_BACKGROUND;
/**
 * @name Banner - Banner component
 * @param {*} props - Strapi cms data
 * @returns {JSX.Element} - Returns Banner Element
 */
const Banner = props => {
  const theme = useTheme();
  const bannerBackground = props?.cmsData?.bannerBackground || LIGHT;
  const {
    backgroundMobile,
    backgroundTablet,
    backgroundDesktop,
    foregroundMobile,
    foregroundDesktop,
    foregroundTablet,
  } = getBannerImage(props);
  const style = useStyles(
    theme,
    backgroundMobile,
    backgroundTablet,
    backgroundDesktop,
    foregroundMobile,
    foregroundDesktop,
    foregroundTablet,
    bannerBackground
  );

  return (
    <Grid container sx={style.bannerContainer}>
      <Grid container maxWidth='lg' sx={style.bannerBoxContainer}>
        <Grid item xs={12} sm={12} md={8} lg={6} sx={style.bannerDetails}>
          <Box sx={style.bannerBox}>
            <Typography component='p' variant='h1' sx={style.bannerTitle}>
              {props.cmsData?.title}
            </Typography>
            {props.cmsData?.description && (
              <Typography component='p' variant='body3Medium' sx={style.bannerDescription}>
                {props.cmsData?.description}
              </Typography>
            )}
            <Box sx={style.bannerCTA}>
              <ActionCTA cta={props?.cmsData?.bannerCTAs} handleAction={props.handleAction} />
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={3}>
          <Box sx={style.bannerForeGround} />
        </Grid>
      </Grid>
    </Grid>
  );
};

Banner.displayName = 'Banner';
export default Banner;
